import { render } from "./MembersPage.vue?vue&type=template&id=8767dea8"
import script from "./MembersPage.vue?vue&type=script&lang=js"
export * from "./MembersPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__